// src/App.js
import React, { useEffect } from "react";
import { Route, Routes, useNavigate, useSearchParams } from "react-router-dom";
import PrivateRoute from "./common/components/PrivateRoute";
import { AuthProvider } from "./common/contexts/AuthContext";
import AccountPage from "./common/pages/AccountPage";
import LoginPage from "./common/pages/LoginPage";
import PasswordResetPage from "./common/pages/PasswordResetPage";
import PasswordResetConfirmPage from "./common/pages/PasswordResetConfirmPage";
import SignupPage from "./common/pages/SignupPage";
import Dashboard from "./pages/Dashboard";
import StageAnalyticsPage from "./pages/StageAnalyticsPage";
import StagePage from "./pages/StagePage";

// Firebase email-action links (handleCodeInApp) land at the app root with
// mode/oobCode as query params and the real destination in `continueUrl`.
// Catch that here and forward to the in-app handler route, preserving params.
function EmailActionRedirect() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  useEffect(() => {
    const mode = params.get("mode");
    const oobCode = params.get("oobCode");
    const continueUrl = params.get("continueUrl");
    if (mode && oobCode && window.location.pathname !== "/reset-password") {
      let targetPath = "/reset-password";
      if (continueUrl) {
        try {
          targetPath = new URL(continueUrl, window.location.origin).pathname || "/reset-password";
        } catch {
          targetPath = "/reset-password";
        }
      }
      navigate(targetPath + (window.location.search || ""), { replace: true });
    }
  }, [params, navigate]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <EmailActionRedirect />
      <Routes>
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard/pages/:eventId/analytics"
          element={
            <PrivateRoute>
              <StageAnalyticsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/account"
          element={
            <PrivateRoute>
              <AccountPage />
            </PrivateRoute>
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/password-reset" element={<PasswordResetPage />} />
        <Route path="/reset-password" element={<PasswordResetConfirmPage />} />
        <Route path="/s/:slug" element={<StagePage />} />
        <Route path="/p/:slug" element={<StagePage previewMode={true} />} />
        <Route path="/" element={<LoginPage />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
